import React from "react";

export function InfoBoard(props) {
    return <div className="infoBoard py-2">{props.children}</div>;
}

const convertAttributes = attributes => {
    if (attributes.name) {
        // Update form field name to enable a post save
        const prefix = `rows[${InfoBoardHelper.sortIndex}][infoboarddata]`;
        let suffix = "";

        if (attributes.name.substr(-1) === "]") {
            suffix = `${attributes.name}`;
        } else {
            suffix = `[${attributes.name}]`;
        }
        attributes.name = prefix + suffix;
    }
    if (!attributes.onChange) {
        attributes.onChange = () => true;
    }
};

export class InfoBoardHelper {
    static sortIndex = 0;

    static renderCheckbox(label, attributes) {
        convertAttributes(attributes);
        const idAttr = `infoboard-check-${attributes.name}`;
        return (
            <div className="custom-control custom-checkbox">
                <input
                    className="custom-control-input"
                    id={idAttr}
                    type="checkbox"
                    {...attributes}
                />
                <label className="custom-control-label" htmlFor={idAttr}>
                    {label}
                </label>
            </div>
        );
    }

    static renderRadioButton(label, attributes) {
        convertAttributes(attributes);
        let idAttr = attributes.id
            ? attributes.id
            : `infoboard-radio-${attributes.name}`;
        return (
            <div className="custom-control custom-radio">
                <input
                    className="custom-control-input"
                    id={idAttr}
                    type="radio"
                    {...attributes}
                />
                <label className="custom-control-label" htmlFor={idAttr}>
                    {label}
                </label>
            </div>
        );
    }

    static renderTextInput(attributes) {
        convertAttributes(attributes);
        return (
            <input
                className="form-control form-control-sm"
                type="text"
                {...attributes}
            />
        );
    }

    static renderReadOnlyText(attributes) {
        convertAttributes(attributes);
        return (
            <input
                className="form-control form-control-sm"
                type="text"
                readOnly
                {...attributes}
            />
        );
    }

    static renderHiddenInput(attributes) {
        convertAttributes(attributes);
        return (
            <input
                className="form-control form-control-sm"
                type="hidden"
                {...attributes}
            />
        );
    }

    static renderSelect(list, attributes) {
        convertAttributes(attributes);
        return (
            <select className="form-control form-control-sm" {...attributes}>
                {list.map(item => (
                    <option key={item.value} value={item.value}>
                        {item.option}
                    </option>
                ))}
            </select>
        );
    }
}
